import domain from './domain';

// Reset notification emails
export const resetNotificationEmails = domain.createEvent('resetNotificationEmails');
